const productCatalog = {
  image_111: 'product_111.jpg',
  desc_111: {
    title: 'ITX-ATOM',
    desc: [
      '支持 ATOM 处理器',
      '板载 VGA/LVDS/DVI 显示',
      '内建 HD 显卡，高清显示',
      '集成 ALC662 声道，板载功放',
      '内建 1*Mini PCIe /SIM 扩展槽，支持 4G/ Wifi',
      '内建 1*MINI-SATA， 2*SATA2.0',
      '支持 8*USB 2.0',
      '支持 6*COM</p>',
      '24 PIN ATX 供电'
    ]
  },
  title_111: ['处理器', '芯片组', '显示芯片', '显示输出', '内存', '声卡', '网卡', '存储', '扩展插槽', 'USB', 'COM', '后置I/O接口', '内部I/O接口', 'BIOS', '供电', '散热系统', '工作环境', '板型'],
  value_111: [
    '集成 Intel® ATOM Celeron®',
    'SOC',
    '集成Intel HD Graphics核心显卡',
    'VGA/LVDS/DVI',
    '1*SO-DIMM DDR3L 1333 MHz插槽，最大容量支',
    '持8GB',
    '板载Realtek ALC662HD音频解码控制器',
    '板载2*Realtek 8111E千兆网卡',
    '2*SATAⅡ  1*MINI-SATA',
    '1*MINI-PCIE(for WIFI)  1*SIM',
    '8*USB2.0（4*USB2.0需扩展）',
    '6*COM(4*COM需扩展)',
    '4*USB2.0端口, 1*VGA端口, 2*COM端口, 2*LAN端口, 1*MIC-IN端口, 1*LINE-OUT, 1*DVI端口, 1*PS/2端口',
    '1*LVDS排针, 1*VGA插针, 1* GPIO插针, 4*COM插针, 1* INVERT插针, 2*USB2.0插针（可扩展4个USB2.0端口）, 1*24PIN ATX 插针, 1*F-AUDIO插针, 1*SPEAKER插针 , 1*F-PANEL插针, 1*PRINT 插针, 1*LPC插针',
    'AMI 64M  BIOS',
    '24PIN ATX供电',
    '主板自带CPU散热器',
    '-10~60；0% ~ 95% 相对湿度,无冷凝',
    '170X170MM  MINI-ITX'
  ],
  image_112: 'product_112.jpg',
  desc_112: {
    title: 'DN-SKC',
    desc: [
      '采用Intel H310芯片组，支持Intel6th Skylake及7th Kabylake-S、8th Coffee lake-S 系列CPU，内置LVDS/eDP显示输出，支持最大支持6*COM，可选TPM安全模块。可应用于工业控制、POS、智能零售、云终端等行业。',
      '支持 Intel Skylake-S &KabyLake-S CPU&Coffee Lake-S',
      'Intel H310 Chipset',
      'HDMI + VGA + LVDS显示接口',
      'DDR3/DDR4 笔记本内存',
      'Max 6个COM',
      '12V~19V DC-IN'
    ]
  },
  title_112: [
    '处理器',
    '芯片组',
    '内存',
    '存储',
    '以太网',
    '后I/O接口',
    '内置接口',
    '尺寸',
    '环境'
  ],
  value_112: [
    '支持intel 第6代、第7代、第8代系列桌面CPU',
    '采用Intel H310C系列芯片组',
    '1 x SO-DIMM DDR3L 1600MHz 最大8G',
    '2 X 标准SATA3.0接口',
    '1*千兆LAN控制器  RTL8111H',
    '4 x USB 3.0, LAN 1（RJ45，千兆）, Display VGA+HDMI, Audio 2（Line_Out+MIC）',
    'M.2 2230 1 支持M.2 2230 WIFI 、BT, M.2 2280 1 支持M.2 2280 SSD PCIe X2, SATA 2*SATA3.0, USB 2*USB2.0标准插针，支持4*USB2.0接口, COM NA 6*2.54mm 2*5Pin插针（COM1可支持供电，跳线选择）, RS485 NA COM5、COM6跳线支持RS485, VGA插针 1 *12Pin插针（可选）, LVDS 支持双8 24BLVDS显示输出，最大分辨率1920*1080',
    '170 * 170 mm',
    '0 ~ 60℃  95% @ 40℃（非凝结）'
  ],
  image_113: 'product_113.jpg',
  desc_113: {
    title: 'DN-APL',
    desc: [
      'Apollo lake系列处理器',
      'DDR3 SODIMM 204 Socket内存插槽最大支持8G',
      '1个RS-232',
      '支持双通道 24 位 LVDS 输出和EDP输出(只能二选一）',
      '板载32/64/128G EMMC存储芯片（可选择）',
      '单输入直流通电源，DC12-19V',
      '结构 120 x 120 mm'
    ]
  },
  title_113: [
    '处理器',
    '内存',
    '视频',
    'I/O接口',
    '网络',
    '音频',
    'Super  I/O',
    '扩展槽',
    '存储',
    '工作环境'
  ],
  value_113: [
    'Apollo lake系列处理器',
    'DDR3 SODIMM 204 Socket',
    'Intel HD Graphics, LVDS支持双通道24位输出,最高分辨率1920 x 1200 EDP最高支持分辨率为3840*2160（LVDS和EDP显示只能二选一）, VGA支持最大分辨率2048x1536, HDMI 最大分辨率支持3840*2160',
    '1*DC 1*VGA 1*HDMI 2*LAN 1*LINE OUT 1*MIC IN 2*USB2.0 2*USB3.0 1*COM口（RJ45接口） 1*电源指示灯和硬盘指示灯 1*复位按钮 1*快速开关按钮带指示灯',
    '2个Intel I211千兆网卡，RJ45接口',
    '瑞昱HD ALC662音频解码(左右声道 + 麦克风)',
    'ITE8613',
    '1个Mini-PCIe插槽,只支持PCIE协议的模块',
    '32/64/128G, 1个标准SATAIII接口, 最大传输速率6Gb/s, 1个 M-SATA Scoket,支持SANDISK协议，最大传输速率 6gb/s',
    '-20℃ ~ +60℃, 0% ~ 90%相对湿度, 无凝露'
  ],
  image_114: 'product_114.jpg',
  desc_114: {
    title: 'DN-GML',
    desc: [
      'Gemini lake系列处理器',
      'DDR3 SODIMM 204 Socket内存插槽最大支持8G',
      '1个RS-232',
      '支持双通道 24 位 LVDS 输出和EDP输出(只能二选一）',
      '板载32/64/128G EMMC存储芯片（可选择）',
      '单输入直流通电源，DC12-19V'
    ]
  },
  title_114: [
    '处理器',
    '内存',
    '视频',
    'I/O接口',
    '网络',
    '音频',
    'Super  I/O',
    '扩展槽',
    '存储',
    '工作环境'
  ],
  value_114: [
    'Gemini lake系列处理器',
    'DDR3 SODIMM 204 Socket',
    'Intel HD Graphics, LVDS支持双通道24位输出,最高分辨率1920 x 1200 EDP最高支持分辨率为3840*2160（LVDS和EDP显示只能二选一）, VGA支持最大分辨率2048x1536, HDMI 最大分辨率支持3840*2160',
    '1*DC 1*VGA 1*HDMI 2*LAN 1*LINE OUT 1*MIC IN 2*USB2.0 2*USB3.0 1*COM口（RJ45接口） 1*电源指示灯和硬盘指示灯 1*复位按钮 1*快速开关按钮带指示灯',
    '2个Intel I211千兆网卡，RJ45接口',
    '瑞昱HD ALC662音频解码(左右声道 + 麦克风)',
    'ITE8613',
    '1个Mini-PCIe插槽,只支持PCIE协议的模块',
    '32/64/128G, 1个标准SATAIII接口, 最大传输速率6Gb/s, 1个 M-SATA Scoket,支持SANDISK协议，最大传输速率 6gb/s',
    '-20℃ ~ +60℃, 0% ~ 90%相对湿度, 无凝露'
  ],
  image_121: 'product_121.jpg',
  desc_121: {
    title: '4U工控机',
    desc: [
      '工业控制计算机',
      '4U 19英寸高性上架式机箱',
      '前置3个抽拉硬盘 支持Raid功能',
      'Intel socket LGA1155封装, 支持双路Xeon E5-2600 V3(Socket R3)系列处理器, QPI最高可达9.6GT/s',
      '支持16根288脚DDR4插槽，支持高达512GB DDR4 ECC RDIMM,单条最大支持32GB,16GB,8GB,4GB•64GBLRDIMM',
      '可配标准PS2 ATX电源, 可配2U 550W(1+1)、700W(1+1)、1000W(1+1)冗余电源',
      '',
      ''
    ]
  },
  title_121: [
    '适配主板',
    '处理器',
    '芯片组',
    '内存',
    'I/O接口',
    '液晶显示',
    '硬盘',
    '光驱',
    '可扩展性',
    '环境',
    '电源',
    '外形尺寸'
  ],
  value_121: [
    '兼容EATX(双路)、ATX两类主板安装(EATX主板配置，可配双路Xeon E5-2600 V3(Socket R3)全系列高阶处理器，板载完善的LSI 专业Raid功能)',
    '主板：支持Intel socket LGA1155封装2nd Generation Intel Core Desktop  Processor 和3nd Generation Intel Core Desktop  Processor, 支持双路Xeon E5-2600 V3(Socket R3)系列处理器, QPI最高可达9.6GT/s',
    '可支持Intel® C612 Chipset 、Intel® Q77/H61/B65/Q67 Express Chipset等',
    '支持16根288脚DDR4插槽，支持高达512GB DDR4 ECC RDIMM,单条最大支持32GB,16GB,8GB,4GB•64GBLRDIMM',
    '机箱前置2个USB 2.0接口，ATX船型开关、复位开关，电源、硬盘指示灯后置接口，根据主板配置而定',
    '6.5″TFT LCD液晶显示屏',
    '支持Raid',
    '1个超薄CD/DVD-ROM位 (面板预留，可选配)',
    '根据主板配置而定，当配单路ATX及双路EATX主板时，支持全高全长直插扩展：双路:(单CPU)1*PCI-E×16+1*PCI-E×8；(双CPU)2*PCI-E×16+4*PCI-E×8',
    '0℃～50℃；5%～90%(非凝结状态)',
    '1、可配标准PS2 ATX电源；2、可配2U 550W(1+1)、700W(1+1)、1000W(1+1)冗余电源',
    '482mm×177mm ×552mm'
  ],
  image_122: 'product_122.png',
  desc_122: {
    title: '视觉工控机',
    desc: [
      '高性能视觉智能整机',
      '外形小巧、多扩展、多型态。具有优良的密封防尘、散热与抗振性能。可以满足污染大、灰尘多、电磁干扰严重等恶劣环境使用。',
      '该产品采用Intel®Sky Lake U的低功耗解决方案，具有高配置，高可靠性，独立微控制系统特点；板载2个Intel千兆网口，其中支持4个POE功能；功能齐全，环境适应性强；可用于机器视觉、高速公路车道控制、机械检测设备、智能交通，工业自动化控制等超广泛应用领域。'
    ]
  },
  title_122: [
    '处理器',
    '内存',
    'I/O接口',
    '存储器',
    '扩展选配',
    '工作环境',
    '存储环境',
    '电源',
    '操作系统',
    '外形尺寸'
  ],
  value_122: [
    'Intel I3/I5/I7',
    '4GB DDR4（MAX16GB）',
    '2个10/100/1000 Mbps，其中4个支持POE符合802.3af标准(可定制), 2*COM，其中1*485, 6*USB，其中4*USB3.0, 1*PS/2, 1*VGA, 1*HDMI1.4a, Line-in、Line-out, 16*GPIO',
    '64G/128G/256G(选配)',
    '1* Mini-PCIE ，1*MSATA',
    '温度：﹣20～50℃ 湿度：5%～ 90%（非凝结状态）',
    '温度：-30℃～60℃ ； 湿度：5%～90%（非凝结状态）',
    '支持12V DC输入，选配60W AC外置适配器',
    'WIN7/WIN8/WIN10, Unix/Linux',
    '262*200*79MM'
  ],
  image_123: 'product_123.png',
  desc_123: {
    title: '加固平板电脑',
    desc: [
      '10.6"手持加固平板电脑',
      '全铝合金外壳',
      '高性能Intel四核四线程CPU，系统处理能力极佳',
      '10.6英寸工业级显示屏，工业级电容触摸屏，拥有良好的线性特性',
      '前面板达IP65防护等级',
      '具有丰富的I/O 接口',
      '广泛适用于各行业'
    ]
  },
  title_123: [
    '触摸屏',
    '屏幕尺寸',
    '处理器',
    '内存',
    'I/O接口',
    '存储器',
    '扩展选配',
    '工作环境',
    '存储环境',
    '电源',
    '操作系统',
    '外形尺寸',
    '外观'
  ],
  value_123: [
    '工业级电容式',
    '10.6, 1920*1080, 400cd/㎡, 900：1',
    'Intel 四核四线程',
    '4GB DDRIII',
    '网口 2*10/100/1000 Mbps, 2*COM, 2*USB（最多可扩展4个USB）, 1*HDMI, Line-out、MIC, 4路GPIO',
    '64G/128G/256G(选配)',
    '1* Mini-PCIE，可扩展无线网卡, 1*SM模块',
    '温度：﹣10～60℃ 湿度：5%～ 90%（非凝结状态）',
    '温度：-20℃～60℃ ； 湿度：5%～90%（非凝结状态）',
    'DC12V输入，随配AC100-240V外置电源适配器, 输入电压9～36VDC（无适配器）',
    'WIN7/WIN8/WIN10, Unix/Linux',
    '324*214*50MM',
    '前面板+壳体高强度铝合金'
  ],
  image_124: 'product_124.jpg',
  desc_124: {
    title: '设备智能工作站',
    desc: [
      '17英寸 一体化液晶工作站',
      '铝合金面板、支持触摸操控',
      '支持Intel ATOM, Celeron全系列处理器',
      '设计冲击: 8G，半正弦，11ms脉冲持续时间',
      '随机振动: 操作时： 5—500 Hz，0.5 Grms，3轴, 非操作时：5—500 Hz，2.46 Grms，3轴',
      '电源: 90-240VAC, 50~ 60Hz 250W/350W/400W(可选)'
    ]
  },
  title_124: [
    '材质/表面',
    '外形尺寸',
    '处理器',
    '内存',
    '硬盘',
    '操作系统',
    'I/O',
    '屏幕',
    '电源',
    '工作环境',
    '存储环境',
    '设计冲击',
    '随机振动'
  ],
  value_124: [
    '铝合金面板，表面带保护涂层',
    '482 ×310× 210 mm（W x H x D）',
    'Intel 处理器（可定制）',
    'DDR3 4GB',
    '1T(可定制)',
    '支持windows7、WindowsXP、NT、LINUX 等多种系统',
    '1×VGA 接口, 1 × USB  接头, 2×RJ45接头, 1 x LPT 1 x PS/2 for KB/MS, 4 x PCI 扩展槽',
    '17寸, 1280x1024, 带触摸',
    '90-240VAC, 50~ 60Hz 250W/350W/400W(可选)',
    '温度：-20°C 至 +80°C, 湿度：10%­ 至 90%，非凝露',
    '温度：-20°C 至 +70°C, 湿度：10% 至 90%，非凝露',
    '8G，半正弦，11ms脉冲持续时间',
    '操作时： 5—500 Hz，0.5 Grms，3轴, 非操作时：5—500 Hz，2.46 Grms，3轴'
  ],
  image_131: ['static/product_131_1.jpg', 'static/product_131_2.jpg'],
  image_132: ['static/product_132.jpg'],
  image_133: ['static/product_133.jpg'],
  image_134: ['static/product_134_1.jpg', 'static/product_134_2.jpg'],
  image_135: ['static/product_135_1.jpg', 'static/product_135_2.jpg'],
  image_136: ['static/product_136_1.jpg', 'static/product_136_2.jpg'],
  image_141: 'product_141.jpg',
  desc_141: {
    title: '服务器',
    desc: [
      '采用英特尔®Skylake C246 芯片组，支持 Intel® Gen8 系列多核处理器，性能同比之前提升 20%，且功率消耗更低',
      '存储背板采用 12Gb SAS Expander 芯片，支持 24 个 3.5’6Gb SAS/SATAIII 热插拔硬盘',
      '冗余风扇、冗余电源，消除单一故障点',
      '对磁盘组采用分时上电方式，有效降低电源负载和对电网的浪涌冲击',
      '支持硬件监测，可远程监控主机电源、风扇等硬件工作状态',
      '支持 Windows、Linux 系统，可提供系统管理 API 资源，实现按需定制化'
    ]
  },
  title_141: [
    '处理器',
    '芯片组',
    '内存',
    '系统盘',
    'I/O',
    '机壳',
    '电源',
    '工作环境'
  ],
  value_141: [
    '8th Generation Intel® Core™ i3/Pentium®/Celeron® Processor, Intel® Xeon® Processor E-2100 series., Single Socket LGA 1151 supported, CPU TDP support Up to 95W TDP',
    'C236',
    '16 x DIMM 插槽，支持DDR4 UDIMM',
    'm.2接口, 24个3.5\'  SATAIII/SAS热插拔硬盘',
    '4个标准RJ45千兆网口，1个IPMI管理口, 4个USB3.0, 1个标准VGA接口（GPU集成）, 1个标准VGA接口（Aspeed AST2500 BMC）, RS-232(DB9)',
    '4U机架式机箱，24个热插拔硬盘盒, 444(宽)x177(高)x670(深), ≤30kg（不含硬盘）',
    '550W（1+1）金牌冗余电源, AC 100～240V，50～60Hz, 80PLUS  GOLD、ROHS、CCC',
    '-10°to 55°C, 8% to 90% (非泠凝)'
  ],
  image_151: 'product_151.gif',
  desc_151: {
    title: 'MB328',
    desc: [
      '采用Rockchip RK3288主芯片',
      '支持4K显示输出',
      '支持双显显示',
      '内置LVDS显示输出接口'
    ]
  },
  title_151: ['处理器', '内存', '显示芯片', '网卡', '后置I/O接口', '内部I/O接口', '大小', '操作系统', '系统管理'],
  value_151: [
    'Onboard ARM RK3288 CPU（四核Cortex-A17，主频最高达1.8G）',
    'Onboard 2G DDR3 Memory（64bit，Max.2G)）',
    'ARM Mali-T764 HDMI+LVDS（1920*1080）',
    '1000M LAN + Onboard WiFi Moudel',
    '1*DC_IN 12V, 1*TF Card Reader, 1* SIM_CARD, 1*HDMI, 1*RJ-45, *2USB2.0, 1*Audio-out',
    '1*Full Mini-PCIe (for USB+PCIe+4G), 1*F_IR, 1*F_Audio, 1*F_Mic in, 1*3Pin S/PDIF port, 1*30Pin LVDS port, 1*4Pin VOL+ &VOL, 1*4Pin SYS FAN, 1*4Pin Speaker port, 1*6Pin COM port（RS232）, 1*6pin COM port（TTL）,*3USB2.0 ',
    '120mm*120mm',
    'Android5.2',
    '*RTC Timer Power-On, *Watch Dog Timer, *Wake-On-Lan *Auto Power-On'
  ],
  image_152: 'product_152.png',
  desc_152: {
    title: 'MB339',
    desc: [
      '3.5寸标准板型  集成LVDS/HDMI OUT/EDP/MIPI视频输出接口功能',
      '丰富的扩展接口选配  8个可扩展串口（支持TTL或RS232,RS485可选）、9个USB(其中4个插针+2个或4个标准USB口+1个TYPEC）、1路HDMI IN可选、1路MIPI 摄像头、4路GPIO、1路IR、1路I2C、1路ADC和Mini PCIE 3G/4G接口',
      '高稳定性, 支持7天无人值守',
      '高清晰度, 最大支持3840x2160的4K解码和各种LVDS/eDP/MIPI等接口的LCD显示屏'
    ]
  },
  title_152: ['处理器', '内存', '存储', '显示', '网络', '串口', 'USB', 'MIPI摄像头', '功放', 'MIC', '耳机', 'I2C', 'GPIO', 'RTC', '红外', '传感器', '开机指示灯', '开关机', '看门狗', '供电', '操作系统', '尺寸'],
  value_152: [
    '瑞芯微 RK3399 双核72+四核A53 1.8GHz+GPU Mail-T860MP4',
    '2GB(4GB可选) 双通道64位DDR3或DDR4',
    '8GB eMMC (16GB/32GB/64GB/128GB可选)',
    'LVDS：支持单或双6位、8位、10位，分辨率1920*1080。EDP：支持分辨率4K*2K@30fps。MIPI：支持单MIPI接口屏，分辨率1920*1080，职高支持4Gbps数据速率。HDMI：最高支持HDMI 2.0 4K 60HZ',
    'RJ45:支持10M/100M/ 1000M网口。WIFI:支持2.4C 802. 11b/g/n (5C 802. 11a/ac可选)。支持蓝牙功能，V2. 1+EDR/BT V3. 0/BT V3. 0+HS/BT。V4.0(BTV4.2可选)支持4C MINI PCIE模块(USB接口)，支持数据上网业务 ',
    '支持8路RS232 (或8路TTL可选，或者4路RS232可选，或者1路RS 485+1路TTL+6路RS232可选) +1路TTL调试串口',
    '支持7路USB2.0+1路USB2.0 OTC',
    'MIPI支持4 Lan, 最高支持1300万像素可选',
    '喇叭最大支持8S2 /6W*2或4 S2/ 12W*2 ',
    '支持一路麦克风输入',
    '支持3.5mm接口立体声输出和麦克风输入',
    '支持1路I2C接口',
    '支持4路GPI0口',
    '支持实时时钟',
    '支持红外摇控接口模块',
    '支持3轴加速度传感器可选',
    '支持红、绿2路指示灯接口',
    '支持通电自动开机或手动开机，支持定时开关机',
    '支持硬件看门狗，软件可配置',
    '输入电压: DC 12V 士0.5V',
    'Android 7. 1/9. 0/Ubuntu 12 . 04可选',
    'PCB:148 m* 102mm*1.6mm'
  ]
}

export default productCatalog
